export const create = {
  createSuccessfully: '新しい洗濯機の部品を作成しました！',
}
